import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const ContactPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Contact | PH Therapy</title>
        <meta name="description" content="Get in touch with PH Therapy. Book a consultation with our AHCS-registered Clinical Exercise Physiologists. London, Wimbledon, Fulham, Kensington, Chiswick, Surrey & Sussex." />
        <link rel="canonical" href="https://www.pandhtherapy.co.uk/contact" />
      </Helmet>
      <Header />
      <Contact />
      <Footer />
    </>
  );
};

export default ContactPage;